import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UserDetails } from 'src/app/components/account/models/UserDetails';
import { EditPersonalDataService } from 'src/app/components/account/services/edit-personal-data.service';
import { RegistrationService } from 'src/app/public/onboarding/services/registration.service';
import Swal from "sweetalert2";

@Component({
  selector: 'app-modal-email',
  templateUrl: './modal-email.component.html',
  styleUrls: ['./modal-email.component.scss']
})
export class ModalEmailComponent implements OnInit {

  public user: string = "Utilizator";
  public problematica: string = "Problematica"
  public subject: string = "Subiect";
  public description: string = "Descriere";
  public serviceDeskEmailForm: FormGroup;
  public email: any;
  public listOfProblemTypes = [
    'Solicitare credentiale broker API',
    'Raportare bug platforma web',
    'Propunere imbunatatire platforma',
    'Alta problematica',
    'Lipsa afisare date de identificare',
  ];

  constructor(
    public activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private personalDataService: EditPersonalDataService,
    private registrationService: RegistrationService
  ) {
  }

  ngOnInit(): void {
    this.createServiceDeskEmailForm();
    this.personalDataService.getPersonalData().subscribe(
      (userDetails: UserDetails) => this.initializeFormFields(userDetails));
  }

  createServiceDeskEmailForm(): void {
    this.serviceDeskEmailForm = this.formBuilder.group({
      from: [{ value: '', disabled: true }],
      problematica: ['', [Validators.required]],
      subject: ['', [Validators.required]],
      description: ['', [Validators.required]],
    });
    this.serviceDeskEmailForm.get('from').addValidators(Validators.required);
  }

  initializeFormFields(userDetails: UserDetails): void {
    this.serviceDeskEmailForm.patchValue({
      from: userDetails.email
    });
  }

  onCancel(): void {
    this.activeModal.dismiss();
  }

  onSendingMail(): void {
    this.serviceDeskEmailForm.markAllAsTouched();
    if (this.serviceDeskEmailForm.invalid) {
      Swal.fire({
        html: '<span>Va rugam sa completati toate campurile pentru a deschide ticket.</span>',
        showConfirmButton: true,
        showCancelButton: false,
        confirmButtonText: 'Confirm',
        cancelButtonText: 'Anuleaza',
        customClass: {
          popup: 'popup-z-elevate-24-red'
        }
      });
      return;
    }
    this.email = {
      from: this.serviceDeskEmailForm.get('from').value,
      //problematica: this.serviceDeskEmailForm.value.problematica,
      subject: this.serviceDeskEmailForm.value.problematica + ' - ' + this.serviceDeskEmailForm.value.subject,
      description: this.serviceDeskEmailForm.value.description
    };

    this.registrationService.sendServiceDeskMailMessage(this.email).subscribe((val) => {
      this.activeModal.close("success");
    });
  }

}
